import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-house',
  templateUrl: './product-house.component.html',
  styleUrls: ['./product-house.component.css']
})
export class ProductHouseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
